module.exports = {
	"endpoints": {
		"hostRunTime": "{{host-run-time || ''}}"
	},
	"httpSettings": {
		"timeout": 9000,
		"reloadQueryParamName": "goto",
		"reloadURL": "/index.html",
		"serviceBaseURLs": {
			"cc": "{{endpoints.hostRunTime}}/cc/service/edge/",
			"cm": "{{endpoints.hostRunTime}}/ab/service/edge/",
			"pc": "{{endpoints.hostRunTime}}/pc/service/edge/",
			"bc": "{{endpoints.hostRunTime}}/bc/service/edge/",
			"quote": "{{endpoints.hostRunTime}}/quote/",
			"journey": "{{endpoints.hostRunTime}}/journey/",
			"vinlookup": "{{endpoints.hostRunTime}}/vehicleinfo/",
			"availability": "{{endpoints.hostRunTime}}/pc/service/edge/gatewaypolicychange/",
			"propertycode": "{{endpoints.hostRunTime}}/pc/service/edge/gatewaypropertycode/",
			"addressLookup": "{{endpoints.hostRunTime}}/address/"
		}
	},
	"userSettings": {
		"sessionConfig": {
			"inactivityIntervalMins": 1440,
			"logoutConfirmationIntervalMins": 1
		},
		"defaultLocaleDetails": {
			"countryCode": "US",
			"mapCenter": {
				"lat": 37.923933,
				"lon": -122.5203
			}
		}
	},
	"appSettings": {
		"AgeAllowedToDrive": 16,
		"MaximumAge": 100,
		"maxFileUploadSize": 50000000,
		"fnolConfig": {
			"firstState": "policySelect",
			"multiplePolicies": true
		},
		"supportPhone": "436-9375-436",
		"statePathConfig": {
			"main_root": "root",
			"billing": "root",
			"fnol": "root",
			"claims": "root",
			"quote_bind": "root",
			"serviceRequests": "root",
			"home": "gatewayLanding",
			"endorsement": "root",
			"faq": "root"
		}
	},
	"auth": {
		"auth0": {
			"clientId": "",
			"url": "",
			"requiresRedirectUrl": true,
			"redirectPath": "",
			"audience": "EdgeBackend",
			"endpoints": {
				"authorize": "/authorize",
				"userinfo": "/userinfo",
				"logout": "/v2/logout"
			},
			"scope": "openid profile",
			"logoutMode": "no-cors",
			"validate": "state",
			"silentLoginParam": "prompt=none",
			"usernameProperty": "name"
		},
		"uaa": {
			"url": "",
			"endpoints": {
				"authorize": "/oauth/authorize",
				"userinfo": "/userinfo",
				"logout": "/logout.do"
			},
			"logoutMode": "cors",
			"validate": "nonce",
			"usernameProperty": "user_name"
		}
	}
}